export const PartsType = {
  Hair: "hair",
  Eyebrow: "eyebrow",
  Eyes: "eyes",
  Nose: "nose",
  Mouth: "mouth",
  Other: "other",
  Glasses: "glasses",
};

export const PartsID = {
  DefaultHair: "default_hair",
  ShavedHair: "shaved_hair",
  BossHair: "boss_hair",
  HeartCostume: "heart_costume",
  DinosaurCostume: "dinosaur_costume",
  KumaCostume: "kuma_costume",
  HiyokoCostume: "hiyoko_costume",
  PandaCostume: "panda_costume",
  FishCostume: "fish_costume",
  SharkCostume: "shark_costume",
  RaccoonCostume: "raccoon_costume",
  CatCostume: "cat_costume",
  SlothCostume: "sloth_costume",
  LionCostume: "lion_costume",
  MouseCostume: "mouse_costume",
  CowCostume: "cow_costume",
  TigerCostume: "tiger_costume",
  RabbitCostume: "rabbit_costume",
  DragonCostume: "dragon_costume",
  SnakeCostume: "snake_costume",
  HorseCostume: "horse_costume",
  SheepCostume: "sheep_costume",
  MonkeyCostume: "monkey_costume",
  BirdCostume: "bird_costume",
  DogCostume: "dog_costume",
  BoarCostume: "boar_costume",
  IchigoCostume: "ichigo_costume",
  PeachCostume: "peach_costume",
  AppleCostume: "apple_costume",
  OrangeCostume: "orange_costume",
  TaiyakiCostume: "taiyaki_costume",
  MaikoCostume: "maiko_costume",
  SuperHeroCostume: "super_hero_costume",
  None: "none",
  Eyebrow: "eyebrow",
  Eyebrow2: "eyebrow2",
  Eyebrow3: "eyebrow3",
  Eyebrow4: "eyebrow4",
  DefaultEyes: "default_eyes",
  KyoroEyes: "kyoro_eyes",
  RoundEyes: "round_eyes",
  CuteEyes: "cute_eyes",
  CuteEyes2: "cute_eyes2",
  SleepingEyes: "sleeping_eyes",
  ClosedEyes: "closed_eyes",
  ClosedEyes2: "closed_eyes2",
  DefaultNose: "default_nose",
  DefaultMouth: "default_mouth",
  DefaultMouth2: "default_mouth2",
  CodRoeMouth: "cod_roe_mouth",
  CloseMouth: "close_mouth",
  OrdinaryGlasses: "ordinary_glasses",
  HeartGlasses: "heart_glasses",
  PharaohGlasses: "pharaoh_glasses",
  Sunglasses: "sunglasses",
  HeartMouth: "heart_mouth",
  NikoMouth: "niko_mouth",
  Heart: "heart1",
  Heart2: "heart2",
  Cactus: "cactus",
  Baby: "baby",
  KumaFigure: "kuma_figure",
  Fun: "fun",
  PowerDrink: "power_drink",
  Kanpai: "kanpai",
  Poem: "poem1",
  Poem2: "poem2"
};
